import axios from 'axios';

export default {
    getFilters(postType = null) {
        var params = {
            action: "get_list_filters",
            post_type: postType
        };
        return axios.get(wp_globals.ajax_url, {params});
    }
}